export enum PrintReceiptTypeEnum {
  OrderReceipt = 'OrderReceipt',
  CardTerminalReceipt = 'ForcePrint',
}
